module.exports = __webpack_public_path__ + "static/bold-titles-33e291326d057e9ec64423c1b89875ba.png";